import {
    VisualModalComponent
} from "../../../../../../components/visual/modal/VisualModalComponent";
import {OfferBlockedComponent} from "../OfferBlockedComponent";
import {OfferProductSolutionType} from "../../../../../../../models/offer/product/solution/OfferProductSolutionType";
import {IOfferBlockedContent} from "../types/IOfferBlockedContent";

export class OfferBlockedModalComponent extends VisualModalComponent {
    constructor(currentQuantity: number, limitQuantity: number, solutionType: OfferProductSolutionType, failureToPay: boolean, content?: IOfferBlockedContent) {
        super();
        this.modalStyle = "width: 530px;padding: 35px;";
        this.noTitle = true;
        this.autoResize = true;
        this.modalTemplate = this.draw(new OfferBlockedComponent(currentQuantity, limitQuantity, solutionType, failureToPay, () => this.close(), content));
    }

    commit() {
        super.commit();
        this.contentContainer.scrollable();
        this.contentContainer.setStyle("position: unset;height: 100%;");
    }
}